import type { AuthConfig } from "../../api/auth";

export const TERMS_NOT_AGREED = "Please agree to the Terms of Service to continue.";

/** The "I agree" box under sign-up, invitation acceptance and the updated-terms
 *  screen. Shown only when the server asks for terms (AuthConfig.terms_version);
 *  the server refuses the account without it either way (backend/app/api/terms.py). */
export function TermsAgreement({ config, agreed, onChange }: {
  config: AuthConfig; agreed: boolean; onChange(agreed: boolean): void;
}) {
  if (!config.terms_version) return null;
  return (
    <label className="terms-agree" data-testid="terms-agree">
      <input type="checkbox" checked={agreed} onChange={(e) => onChange(e.target.checked)} data-testid="terms-checkbox" />
      <span>
        I agree to the{" "}
        <a href={config.terms_url ?? "#"} target="_blank" rel="noopener noreferrer" data-testid="terms-link">ModelBench Terms of Service</a>
        {" "}and have read the{" "}
        <a href={config.privacy_url ?? "#"} target="_blank" rel="noopener noreferrer" data-testid="privacy-link">Privacy Notice</a>.
      </span>
    </label>
  );
}
